/**
 * Run `fn` after React has finished committing the current render.
 *
 * Editor inserts that mount a React NodeView (e.g. the canvas embed) must NOT
 * run synchronously inside an event handler that also unmounts React subtrees
 * (the slash-menu / picker closing). Doing so mounts the NodeView mid-commit,
 * which throws a `flushSync` reentrancy error and wedges the y-prosemirror
 * PM→Y binding — the node renders in the view but never reaches the Y.Doc, so
 * it vanishes on the next remount (tab switch / reload).
 *
 * Two animation frames reliably land after the unmount commit has flushed.
 */
export function deferToAfterCommit(fn: () => void): void {
  requestAnimationFrame(() => requestAnimationFrame(fn));
}
